import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Autocomplete, Box, Button, Group, Modal, Paper, Text } from '@mantine/core';
import { IoMdSearch } from 'react-icons/io';
import classes from './ProductSelection.module.css';
import useFetch from '../../../../../Customhooks/useFetch';
import { baseUrl } from '../../../../../Constants/constant';
import ProductDetails from './ProductDetails.component';

interface ProductSelectionProps {
  isOpen: boolean;
  onClose: () => void;
  categoryId: any;
  categoryName: string;
}

const ProductSelection: React.FC<ProductSelectionProps> = ({ isOpen, onClose, categoryId, categoryName }) => {
  const [isProduct, setIsProduct] = useState<string>('default');
  const [Products, setProducts] = useState<any>();
  const [selectedProduct, setSelectedProduct] = useState<any>();
  const [selectedLabel, setSelectedLabel] = useState<any>('');
  const token = localStorage.getItem("token");

  const { data: getData, fetchData: getVerticals } = useFetch({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: token,
    },
  });

  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        setIsProduct('default');
        setSelectedProduct(null);
        setSelectedLabel('');
        setProducts([]);
      }, 300);
    }
  }, [isOpen]);

  useEffect(() => {
    if (isProduct === 'yes' && categoryId) {
      getVerticals(`${baseUrl}admin/products?category_id=${categoryId}`)
    }
  }, [isProduct, categoryId]);
  useEffect(() => {
    if (getData?.data?.rows) {
      setProducts(
        getData.data.rows.map((el: any) => ({
          value: el.id.toString(),
          label: el.name,
        }))
      );
    }
  }, [getData]);
  const handleProductChange = useCallback((value: string) => {
    setSelectedLabel(value);
    const selectedObj = Products.find((item: any) => item.label === value) || null;
    setSelectedProduct(selectedObj);
  }, [Products]);


  return (
    <div>
      <Modal
        opened={isOpen}
        onClose={onClose}
        size="xl"
        title={categoryName}
        centered
        styles={{
          content: {
            height: (selectedProduct || isProduct === 'no') ? "auto" : "100%",
          },
        }}
      >
        {isProduct === 'default' && (
          <Paper shadow="xl" withBorder p="sm" className={classes.checkproduct}>
            <Box>
              <Text>Do you want to add an Existing Product?</Text>
            </Box>
            <Box>
              <Group>
                <Button variant="default" radius="md" onClick={() => setIsProduct('yes')}>
                  Yes
                </Button>
                <Button variant="default" radius="md" onClick={() => setIsProduct('no')}>
                  No
                </Button>
              </Group>
            </Box>
          </Paper>
        )}

        {isProduct === 'yes' && (
          <Autocomplete
            label="Search"
            variant="filled"
            radius="md"
            withAsterisk
            data={Products}
            placeholder="Search by Product name"
            leftSection={<IoMdSearch />}
            value={selectedLabel}
            onChange={handleProductChange}
            comboboxProps={{ withinPortal: false, shadow: 'md' }}
          />
        )}
        {(isProduct === 'no' || selectedProduct) && <ProductDetails isProduct={isProduct} id_p={selectedProduct?.value} onClose={onClose} />}
      </Modal>
    </div>
  );
};

export default memo(ProductSelection);
